/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationEntity
 */
export interface OrganizationEntity {
    /**
     * 組織ID
     * @type {string}
     * @memberof OrganizationEntity
     */
    id: string;
    /**
     * 組織名
     * @type {string}
     * @memberof OrganizationEntity
     */
    name?: string;
    /**
     * 顧客ID
     * @type {string}
     * @memberof OrganizationEntity
     */
    customerId?: string;
    /**
     * 作成日時
     * @type {Date}
     * @memberof OrganizationEntity
     */
    createdAt: Date;
    /**
     * 最終更新日時
     * @type {Date}
     * @memberof OrganizationEntity
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the OrganizationEntity interface.
 */
export function instanceOfOrganizationEntity(value: object): value is OrganizationEntity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function OrganizationEntityFromJSON(json: any): OrganizationEntity {
    return OrganizationEntityFromJSONTyped(json, false);
}

export function OrganizationEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function OrganizationEntityToJSON(json: any): OrganizationEntity {
    return OrganizationEntityToJSONTyped(json, false);
}

export function OrganizationEntityToJSONTyped(value?: OrganizationEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'customerId': value['customerId'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

